import { render } from "./Photoshoots.vue?vue&type=template&id=407a0bca"
import script from "./Photoshoots.vue?vue&type=script&lang=js"
export * from "./Photoshoots.vue?vue&type=script&lang=js"

import "./Photoshoots.vue?vue&type=style&index=0&id=407a0bca&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__